<template>
  <div class="conditions-item-cont" :class="{ 'one-filter-item': filterList.length === 1 }">
    <div class="'conditions-left-line'"></div>
    <div
      class="filter-type"
      :class="{ 'filter-type-disabled': disabled }"
      @click="
        () => {
          !disabled && handleChangeFilterType();
        }
      "
      v-if="filterList.length > 1"
    >
      {{ filterType === 'and' ? '且' : '或' }}
    </div>
    <condition-filter-item
      v-for="(item, filterItemIdx) in filterList"
      :key="item.column + item.conditionOperator + filterItemIdx"
      :prop-column.sync="item.column"
      :prop-chinese-name.sync="item.chineseName"
      :prop-condition-operator.sync="item.conditionOperator"
      :prop-value.sync="item.value"
      :filter-events="filterEvents"
      :size="size"
      :disabled="disabled"
      :condition-property-options="conditionPropertyOptions"
      :condition-operator-options="conditionOperatorOptions"
      @removeFilterItem="
        () => {
          handleRemoveFilterItem(filterItemIdx);
        }
      "
    ></condition-filter-item>
  </div>
</template>

<script>
import ConditionFilterItem from './condition-filter-item.vue';

export default {
  name: 'ConditionFilter',
  components: {
    ConditionFilterItem,
  },
  props: {
    size: {
      type: String,
      default: 'medium',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    filterList: {
      type: Array,
      required: true,
    },
    filterType: {
      type: String,
      required: false,
    },
    conditionPropertyOptions: {
      type: Array,
      required: true,
    },
    conditionOperatorOptions: {
      type: Array,
      required: true,
    },
    allEventEventPropertyList: {
      type: Array,
      default: () => [],
    },
    filterEvents: {
      type: String,
      default: '',
    },
    filterPropertyFn: {
      type: Function,
      default: () => true,
    },
  },
  computed: {
    //
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    handleChangeFilterType() {
      this.$emit('update:filterType', this.filterType === 'and' ? 'or' : 'and');
    },
    handleRemoveFilterItem(idx) {
      // eslint-disable-next-line vue/no-mutating-props
      this.filterList.splice(idx, 1);
      if (this.filterList.length <= 0) {
        this.$emit('onEmpty');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.conditions-item-cont {
  position: relative;
  box-sizing: border-box;
  padding-left: 52px;
  //padding: 12px 0 12px 40px;

  &:before {
    content: '';
    position: absolute;
    z-index: 1;
    left: 30px;
    display: block;
    width: 1px;
    height: calc(~'100% - 0px');
    background-color: #ddd;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  //&.one-filter-item:before {
  //  width: 8px;
  //  height: 1px;
  //  background-color: #222;
  //}

  .filter-type {
    position: absolute;
    z-index: 2;
    left: 20px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 20px;
    height: 20px;
    background: #ffffff;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    border-radius: 2px;
    line-height: 18px;
    text-align: center;
    font-weight: 500;
    font-size: 12px;
    color: #333333;
    cursor: pointer;
    user-select: none;

    &.filter-type-disabled {
      background-color: #fafafa;

      &:hover {
        border: 1px solid #dddddd;
        color: #333333;
      }
    }

    &:hover {
      border: 1px solid #5a66ff;
      color: #5a66ff;
    }
  }
}
</style>
